<div *ngIf="path !== '/auth/login'">
  <div class="hidden md:block" *transloco="let t">
    <div class="w-full flex fixed top-0 left-0 z-[9999]">
      <div
        class="h-20 w-[90px] bg-[#6F9CAA] flex flex-col items-center justify-between pt-5 border-r border-r-secondary border-b border-b-secondary">
        <svg width="28px" height="27.2px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g fill="#FFFFFF">
              <path
                d="M18.36,52 L36.601,52 C36.756,41.723 42.72,32.87 51.359,28.557 L51.359,7.409 C30.26,13.368 18.36,28.836 18.36,52"
                id="Fill-1"></path>
              <path
                d="M22.59,21.959 C16.475,14.312 10.124,10.268 0,7.409 L0,28.557 C7.953,32.527 13.627,39.76 14.599,48.997 C15.191,38.049 16.821,29.976 22.59,21.959"
                id="Fill-2"></path>
              <path
                d="M25.264,18.291 C28.479,14.627 30.942,12.75 35.066,10.044 L25.53,0.585 L15.847,9.749 C20.007,12.465 22.169,14.497 25.264,18.291"
                id="Fill-3"></path>
            </g>
          </g>
        </svg>
        <div class="flex w-full hover:bg-[#325865] cursor-pointer h-[21px]" (click)="toggleNav()">
          <fa-icon class="text-white m-auto text-sm flex items-center" [icon]="angleDown"
            [ngClass]="{ 'rotate-180': !(hideSideNav | async) }"></fa-icon>
        </div>
      </div>
      <div class="w-[calc(100%-90px)] h-20 overflow-hidden border-b border-b-secondary">
        <lm-page-header [pageTitle]="pageTitle" [breadcrumbs]="breadcrumbs">

          <div class="flex items-center justify-end gap-x-4">
            <div class="  w-[100px] mr-5 custom-select-language"><div class="w-[100px] fixed top-5"> <lm-ng-select [whatever]="siteLanguage" customValue="key" customKey="label" [data]="languageList"
              (onValueChange)="changeLanguage($event);"></lm-ng-select></div></div>

            <span class="cursor-pointer text-xs font-medium"><span> {{ user.preferred_username }}</span></span>
          </div>
        </lm-page-header>
      </div>
    </div>
    <nav *ngIf="!(hideSideNav | async)" class="w-[90px] bg-primary fixed h-screen z-[9999] border-r border-secondary">
      <ul class="flex flex-col items-center h-[calc(100vh-80px)]" (outsideClick)="closeAllSubmenu()">
        <li *ngFor="let item of items; let i = index"
          class="w-full max-h-[90px] flex flex-col justify-center items-center flex-1 cursor-pointer gap-y-2 text-center">
          <div *ngIf="item.action"
            class="w-full flex flex-col justify-center items-center flex-1 cursor-pointer gap-y-2">
            <img *ngIf="item.icon" [src]="item.icon" color="light" (click)="manageAction(item.action)" />
            <p class="uppercase text-2xs text-white">{{ t(item.label) }}</p>
          </div>
          <div *ngIf="!item.children && !item.action" routerLink="{{ item.url }}" (click)="closeAllSubmenu()"
            class="w-full flex flex-col justify-center items-center flex-1 cursor-pointer gap-y-2"
            [ngClass]="{'!bg-secondary':i=== subMenuIndex || myLocation.pathname.includes(item.url)}">
            <img *ngIf="item.icon" [src]="item.icon" color="light" />
            <p class="uppercase text-2xs text-white">{{ t(item.label) }}</p>
          </div>
          <div *ngIf="item.children && !item.action" class="w-full h-full flex justify-center items-center">
            <div [ngClass]="{'!bg-secondary':i=== subMenuIndex || myLocation.pathname.includes(item.url)}" (click)="closeAllSubmenu(); toggleSubmenu(i, item.index)"
              class="w-full h-full flex flex-col justify-center items-center flex-1 gap-y-2 active:bg-secondary">
              <img *ngIf="item.icon" [src]="item.icon" color="light" />
              <p class="uppercase text-2xs text-white">{{ t(item.label) }}</p>
            </div>
            <ul *ngIf="submenu[i]"
              class="flex flex-col items-center justify-start h-[calc(100vh-80px)] fixed -z-10 left-[90px] top-[80px] bg-[#B4CBD2] pt-5 gap-y-1 cursor-default w-[280px]">
              <li class="w-full flex flex-col"
                *ngFor="let item of item.children" (click)="!item.children && closeAllSubmenu()">
                <div class="w-full flex items-center cursor-pointer gap-x-4 text-secondary hover:text-white py-2.5 p-[30px]" [routerLink]="item.url != '#' ? item.url : null" (click)="item.opened = !item.opened">
                  <img class="text-xl text-inherit min-w-[20px] flex justify-center" *ngIf="item.icon" [src]="item.icon" color="dark" />
                  <p class="uppercase text-xs text-inherit font-medium text-center">{{ t(item.label) }}</p>
                  <div>
                    <fa-icon *ngIf="item.children && !item.opened" [icon]="angleDown" color="dark" class="text-xs text-inherit min-w-[20px] flex justify-center"></fa-icon>
                    <fa-icon *ngIf="item.children && item.opened" [icon]="angleUp" color="dark" class="text-xs text-inherit min-w-[20px] flex justify-center"></fa-icon>
                  </div>
                </div>
                <div *ngIf="item.children && item.opened" class="w-full py-2.5 bg-[#C9E0E6]">
                  <div class="w-full flex items-center cursor-pointer gap-x-4 text-secondary hover:text-white py-2.5 bg-[#C9E0E6] p-[30px]" *ngFor="let subitem of item.children" [routerLink]="subitem.url" (click)="toggleSubmenu(i, item.index); this.getCurrentRoute();">
                    <img class="text-xl text-inherit min-w-[20px] flex justify-center" *ngIf="item.icon" [src]="item.icon" color="dark" />
                    <p class="uppercase text-xs text-inherit font-medium text-center">{{ t(subitem.label) }}</p>
                  </div>
                </div>
              </li>
              <li class="absolute bottom-4 text-xs text-secondary text-left left-7">
                <div class="mb-4">
                  <a href="./terms-conditions/faq" target="_blank">{{ t('menu.faq_link') }}</a>
                </div>
                <div>
                  <a href="./terms-conditions" target="_blank">{{ t('menu.terms_link') }}</a>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>

  <div class="flex justify-center md:hidden" *transloco="let t">
    <div class="fixed rounded-full border border-light-gray bottom-5 bg-white z-[9]"
      [ngClass]="collapsed ? 'w-fit p-2.5' : 'w-4/5 py-2 px-8'">
      <ul class="flex justify-center gap-x-12">
        <li *ngIf="!collapsed" class="flex flex-col items-center px-2" routerLink="/dashboard">
          <fa-icon [icon]="faHome" class="font-light text-2xl -mt-0.5"></fa-icon>
          <span class="text-2xs">{{ t('menu.home') }}</span>
        </li>
        <li class="flex flex-col items-center px-2" routerLink="/menu">
          <fa-icon [icon]="faGrid" class="font-light text-2xl -mt-0.5"></fa-icon>
          <span class="text-2xs">{{ t('menu.menu') }}</span>
        </li>
        <li (click)="goToAccount()" *ngIf="!collapsed" class="flex flex-col items-center px-2">
          <fa-icon [icon]="faUser" class="font-light text-2xl -mt-0.5"></fa-icon>
          <span class="text-2xs">{{ t('menu.account') }}</span>
        </li>
      </ul>
    </div>
    <!-- <div class="w-full mb-16">
      <router-outlet></router-outlet>
    </div> -->
  </div>
</div>
<div *ngIf="path === '/auth/login'"></div>
<div [ngClass]="{ 'md:ml-[90px]': !(hideSideNav | async) && !isLogin(), 'w-full md:w-auto md:mt-20': !isLogin() }">
  <router-outlet></router-outlet>
</div>
